import { render, staticRenderFns } from "./ReceiveV2.vue?vue&type=template&id=9b621e5c"
import script from "./ReceiveV2.vue?vue&type=script&lang=js"
export * from "./ReceiveV2.vue?vue&type=script&lang=js"
import style0 from "./ReceiveV2.vue?vue&type=style&index=0&id=9b621e5c&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports